import React from 'react';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import { noop } from 'lodash';

interface FormContext {
  alert: ManualAlert | {};
}

export const FormContext =  React.createContext<FormContext>({
  alert: {},
});

export interface IAction {
  onEdit: (a: ManualAlert) => void;
  onDelete?: (a: ManualAlert) => void;
  onCreate?: () => void;
  onCancel: () => void;
}

interface AlertSummaryContext {
  formVisible: boolean;
  actions: IAction;
}

export const FormActionContext =  React.createContext<AlertSummaryContext>({
  actions: {
    onEdit: noop,
    onDelete: noop,
    onCreate: noop,
    onCancel: noop,
  },
  formVisible: false,
});
